import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import { Field } from "formik";
import { useState } from "react";
import CopyButton from "../copy_button";

export default function InputPassword({
	name,
	label,
	sx,
	size = "medium",
	show = false,
	copy = false,
	placeholder = "",
}) {
	const [showPassword, setShowPassword] = useState(false);

	return (
		<Field name={name}>
			{({ field, meta }) => {
				// PREVENT ERRORS WHEN DATA NOT LOADED YET
				if (!field.value) {
					field.value = "";
				}

				return (
					<FormControl variant="outlined" error={meta.error && meta.touched} sx={{ ...sx }}>
						<InputLabel size={size === "medium" ? "normal" : size} htmlFor={name}>
							{label}
						</InputLabel>
						<OutlinedInput
							size={size}
							aria-describedby={name}
							autoComplete="current-password"
							error={meta.error && meta.touched}
							id={name}
							label={label}
							name={name}
							onChange={field.onChange}
							type={showPassword ? "text" : "password"}
							placeholder={placeholder}
							endAdornment={
								<>
									{/* ------------------------------ SHOW PASSWORD ----------------------------- */}
									<InputAdornment position="end">
										{copy && <CopyButton sx={{ mx: 0 }} value={field.value} />}
										{show && (
											<IconButton
												aria-label="toggle password visibility"
												onClick={() => setShowPassword(!showPassword)}
												edge="end"
											>
												{showPassword ? <VisibilityOff /> : <Visibility />}
											</IconButton>
										)}
									</InputAdornment>
								</>
							}
							{...field}
						/>

						<FormHelperText id={name} sx={{ color: "error.main" }}>
							{meta.error && meta.touched && meta.error}
						</FormHelperText>
					</FormControl>
				);
			}}
		</Field>
	);
}
